const styles = () => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    overflow: 'auto',
    minHeight: 0,
    paddingTop: 32,
  },

  listItem: {
    '&:hover $listArchiveFormIcon': {
      display: 'flex',
    },
  },

  listMeta: {
    lineHeight: '40px',
    display: 'flex',
  },

  listMetaCount: {
    marginLeft: 20,
    width: 50,
    textAlign: 'right',
  },

  listArchiveForm: {
    marginLeft: 35,
    width: 40,
    height: 40,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '&:hover $listArchiveFormIcon': {
      fill: '#616A74',
    },
  },

  listArchiveFormIcon: {
    height: 20,
    lineHeight: '40px',
    display: 'none',
  },
});

export default styles;
